import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, c = /* @__PURE__ */ o("path", { d: "M30.357 6.306a.966.966 0 0 0-.675.279L11.961 24.303l17.7 17.7a.96.96 0 0 0 1.353 0l1.359-1.353a.955.955 0 0 0 .21-.3.977.977 0 0 0 0-.736.948.948 0 0 0-.21-.311l-15-15 15-15a.946.946 0 0 0 .207-.3.963.963 0 0 0 .075-.366.978.978 0 0 0-.075-.369.946.946 0 0 0-.207-.3l-1.359-1.353a.969.969 0 0 0-.657-.309Z" }, null, -1), l = [
  c
];
function r(a, s) {
  return e(), t("svg", n, l);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
//# sourceMappingURL=chevron-left.svg.mjs.map
